const en_US = {
  qsTitle: "All questions",
  appDownLoad: 'APP DownLoad'
};
export default en_US;